'use strict';

var StrategiesFromTemplateController = function StrategiesFromTemplateController($scope, strategiesService, serializeStrategyService, $filter) {
  var rmMomentFormat = $filter('rmMomentFormat');
  $scope.setSelectedStrategyRow = function (strategy) {
    if (!$scope.isSelected(strategy)) {
      $scope.showStrategyPreview(strategy);
    } else {
      $scope.deselectStrategy();
    }
  };
  $scope.isSelected = function (strategy) {
    return $scope.selectedStrategy === strategy;
  };
  $scope.showStrategyPreview = function (strategy) {
    $scope.selectedStrategy = strategy;
  };
  $scope.deselectStrategy = function () {
    $scope.selectedStrategy = null;
  };
  $scope.selectDefault = function () {
    if ($scope.strategyTemplate && $scope.strategies.length > 0) {
      $scope.showStrategyPreview($scope.strategies[0]);
    }
  };
  $scope.createNew = function () {
    $scope.$emit('strategy:createStrategy', $scope.strategyTemplate.id);
    $scope.closePanelHandler();
  };
  $scope.populateStrategies = function () {
    if ($scope.strategyTemplate) {
      $scope.strategies = strategiesService.getStrategiesFromTemplate($scope.strategyTemplate).map(function (strategy) {
        var res = strategiesService.copyStrategy(strategy);
        res.lastUpdatedAt = rmMomentFormat(res.lastUpdatedAt, 'DATE_USER_SETTINGS');
        return serializeStrategyService.parseStrategy(res);
      });
    }
  };
};
StrategiesFromTemplateController.$inject = ['$scope', 'StrategiesService', 'SerializeStrategyService', '$filter'];
module.exports = StrategiesFromTemplateController;